export default "__VITE_ASSET__DJ4O3hNJ__"